
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bike, ChefHat, Monitor, FileBarChart, Settings, BookOpenText, Package } from 'lucide-react';
import { useStore } from '../context/StoreContext';

export const BottomNavbar = () => {
    const location = useLocation();
    const { currentCompany } = useStore();

    const navItems = [
        { path: '/pos', label: 'PDV', icon: Monitor },
        { path: '/menu', label: 'Produtos', icon: BookOpenText },
        ...(currentCompany?.useKitchenDisplay ? [{ path: '/kitchen', label: 'Cozinha', icon: ChefHat }] : []),
        ...(currentCompany?.useDelivery === true ? [{ path: '/delivery', label: 'Delivery', icon: Bike }] : []),
        ...(currentCompany?.useStockManagement ? [{ path: '/stock', label: 'Estoque', icon: Package }] : []),
        { path: '/reports', label: 'Relatórios', icon: FileBarChart },
        { path: '/settings', label: 'Ajustes', icon: Settings },
    ];

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 h-16">
            <div className="flex justify-around items-center h-full">
                {navItems.map(item => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link to={item.path} key={item.path} className="flex flex-col items-center justify-center text-center w-full h-full">
                            <item.icon className={`w-5 h-5 mb-1 transition-colors ${isActive ? 'text-brand-600' : 'text-gray-400'}`} />
                            <span className={`text-[10px] font-bold transition-colors ${isActive ? 'text-brand-600' : 'text-gray-500'}`}>{item.label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
};
